if (!String.prototype.padStart) {
  String.prototype.padStart = function (count, str) {
    return (str || ' ').repeat(count - this.length).substr(0, count) + this;
  };
}
